import { TwitterPostLength } from '../schemas/TwitterPlanning'

export enum PostLength {
  FiveToTenWords = '5-10 words',
  TenToTwentyFiveWords = '10-25 words',
  TwentyFiveToFiftyWords = '25-50 words',
  FiftyToSeventyFiveWords = '50-75 words',
  SeventyFivetoOneHundredWords = '75-100 words',
  OneHudredPlusWords = '100+ words',
}

export const postLengthToNumber = (length?: string) => {
  switch (length) {
    case PostLength.FiveToTenWords: {
      return 0
    }
    case PostLength.TenToTwentyFiveWords: {
      return 1
    }
    case PostLength.TwentyFiveToFiftyWords: {
      return 2
    }
    case PostLength.FiftyToSeventyFiveWords: {
      return 3
    }
    case PostLength.SeventyFivetoOneHundredWords: {
      return 4
    }
    case PostLength.OneHudredPlusWords: {
      return 5
    }
    case TwitterPostLength.UpToOneHundredAndFortyCharacters: {
      return 0
    }
    case TwitterPostLength.BetweenOneHundredAndFortyAndTwoHundredAndEightyCharacters: {
      return 1
    }
    default: {
      return 1
    }
  }
}
